export const gift = {
  giftSubscriptionActivated: "Gift purchase successful, check email!",
  downloadOurApp: "Download our app on iOS and Android",
};
